import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
import { getTrackingClient } from './dependencies';
import { PROPERTIES_TO_SCRUB } from '../constants';
import { scrubEvents } from '../scrubEvents';
export const getAnonymousTrackingClient = user => getTrackingClient({
  storage: anonymousStorage,
  user,
  onSendEventsHook: events => scrubEvents(events, PROPERTIES_TO_SCRUB, '**********')
});